export const Colors = {
  PageBackground: '#f1f5f9',
  White: '#ffffff',
  Blue: '#00447e',
  AlertBgBlue: '#ECF8FE',
  AlertTextBlue: '#1D4D62',
  Menu: '#1a3175',
  MenuActive: '#304993',
  MenuText: '#000000',
  MenuIcon: '#156a9e',
  LinkColor: '#1a3175',
  HeaderTextColor: '#505050',
  Orange: {
    Light: '#f49600',
    Main: '#ff9800',
    Dark: '#e68a00',
  },
  Secondary: {
    Main: '#007962',
  },
  ChipColors: {
    Green: '#00af83',
    Red: '#e11f51',
    Yellow: '#FC9B25',
    Blue: '#1cb2f6',
    DustyBlue: '#d7e6f5', // Används för email-chip
  },
  ColorBox: {
    Blue: '#016893',
    Aqua: '#1cb2f6',
    Green: '#97c95c',
    Yellow: '#ffc820',
    Orange: '#f88600',
    Red: '#e2404b',
    LightBlue: '#99c2ff',
  },
  Form: {
    DisabledInput: '#f6f6f6',
    OutlinedInput: '#c4c4c4',
  },
};
